import React from "react";
import PaymentMethod from "../../components/Payment/PaymentMethod/PaymentMethod";

const PaymentMethodPage = () => {
    return <PaymentMethod />;
};

export default PaymentMethodPage;
